import axios from 'axios';
import {apiServerHost} from '../../common/APIServerSettings';

import { DEV_API_FLAG } from '../../common/API'

/**
 * 리스폰스의 컨디션을 업데이트
 * @param {Function} callBackFunc 
 * @param {Number} responseID 
 * @param {Number} mapperID 
 * @param {String} conditionText 
 */
const updateCondition = (callBackFunc, responseID, mapperID, conditionText) => {
  const params = new URLSearchParams();
  
  params.append("responseID", responseID);
  params.append("mapperID", mapperID);
  params.append("condition", conditionText);
  axios.post(apiServerHost + `/manage/topic/builder${DEV_API_FLAG ? '/dev' : ''}/update/response/condition`, params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

/**
 * 리스폰스에 컨디션을 추가
 * @param {Function} callBackFunc 
 * @param {Number} responseID 
 * @param {String} conditionText 
 */
const createCondition = (callBackFunc, responseID, conditionText) => {
  const params = new URLSearchParams();
  params.append("responseID", responseID);
  params.append("condition", conditionText);
  axios.post(apiServerHost + `/manage/topic/builder${DEV_API_FLAG ? '/dev' : ''}/create/condition`, params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

/**
 * 리스폰스의 컨디션을 삭제
 * @param {Function} callBackFunc 
 * @param {Number} responseUpdateID 
 * @param {Number} mapperUpdateID 
 */
const deleteCondition = (callBackFunc, responseUpdateID, mapperUpdateID) => {
  const params = new URLSearchParams();
  params.append("responseID", responseUpdateID);
  params.append("mapperID", mapperUpdateID);
  axios.post(apiServerHost + `/manage/topic/builder${DEV_API_FLAG ? '/dev' : ''}/delete/condition`, params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

export {updateCondition};
export {createCondition};
export {deleteCondition};